const messages = {
	participantProgram: 'Participation Program',
	fullOutcomes: 'Full Outcomes',
	outcomesLite: 'Outcomes Lite',
	changesSavedSuccessfully: 'Changes saved successfully'
};


function getLocalizedString(key) {
	let result = messages[key] || '';
	return result;
}


module.exports = {
	getLocalizedString
}



// WEBPACK FOOTER //
// ./src/locales/en.js